import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { organiserQueryOptions, womenTripsQueryOptions } from "../api/women-query";

/** The hub's cards; prefetched by the route loader, so it never suspends there. */
export function useWomenTrips(lang: string) {
  return useSuspenseQuery(womenTripsQueryOptions(lang));
}

/**
 * The same cards for the home entry. Not suspending: the home page shows the
 * banner only once it knows there is a trip to point at, and never waits on it.
 */
export function useWomenTripsSoft(lang: string) {
  return useQuery({ ...womenTripsQueryOptions(lang), throwOnError: false, retry: 0 });
}

export function useOrganiser(slug: string, lang: string) {
  return useSuspenseQuery(organiserQueryOptions(slug, lang));
}
